import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { closeReviewProductDialog } from './other/actions';
import ProductForm from './ProductForm';

const useStyles = makeStyles(() => ({
  drawerPaper: {
    borderRadius: '15px 0px 0px 0px',
    width: '41vw',
    overflowX: 'hidden'
  }
}));

/**
 * Drawer permettant d'afficher les informations de la commande dans la partie
 * stock
 * @param {Boolean}  isOpen              Status du drawer ouver ou fermer
 * @param {Function} dispatchCloseDrawer Function permettant de fermer le drawer
 * @param {Object}   currentItem         Object representer l'objet à afficher dans le drawer
 * @param {Boolean}  loading             Indiquer si la rêquete est en cours
 */
const ProductDrawer = ({
  openReviewProductDialog,
  dispatchCloseDrawer,
  currentProduct
}) => {
  const classes = useStyles();
  return (
    <SwipeableDrawer
      classes={{
        paper: classes.drawerPaper
      }}
      anchor="right"
      onOpen={() => null}
      onClose={() => {
        dispatchCloseDrawer();
      }}
      open={openReviewProductDialog}
    >
      <div style={{ marginLeft: 20, marginRight: 20 }}>
        <h1>
          {currentProduct.name} - {currentProduct.reference}
        </h1>
        <ProductForm />
      </div>
    </SwipeableDrawer>
  );
};

const mapStateToProps = state => ({
  openReviewProductDialog: state.importProducts.openReviewProductDialog,
  currentProduct: state.importProducts.currentProduct
});

const mapDispatchToProps = dispatch => ({
  dispatchCloseDrawer: () => dispatch(closeReviewProductDialog())
});

ProductDrawer.propTypes = {
  openReviewProductDialog: PropTypes.bool.isRequired,
  dispatchCloseDrawer: PropTypes.func.isRequired,
  currentProduct: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDrawer);
